var _path, _path2, _path3, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotorDeCurentAlternativ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 82,
    viewBox: "0 0 85 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 60C34.0589 60 26 51.9411 26 42C26 32.0589 34.0589 24 44 24C53.9411 24 62 32.0589 62 42C62 51.9411 53.9411 60 44 60Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1477 36.3636H40.7273L44.1818 44.7955H44.3182L47.7727 36.3636H50.3523V48H48.3295V40.0057H48.2216L45.0057 47.9659H43.4943L40.2784 39.9886H40.1705V48H38.1477V36.3636Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.483 53.1136C39.4702 52.4062 39.5852 51.8374 39.8281 51.407C40.071 50.9766 40.3864 50.6634 40.7741 50.4673C41.1662 50.2713 41.5795 50.1733 42.0142 50.1733C42.4489 50.1733 42.8452 50.2692 43.2031 50.4609C43.5653 50.6484 43.9787 50.9446 44.4432 51.3494C44.7585 51.6222 45.0099 51.8139 45.1974 51.9247C45.3892 52.0355 45.598 52.0909 45.8239 52.0909C46.1903 52.0909 46.4801 51.9588 46.6932 51.6946C46.9063 51.4261 47.0085 51.0384 47 50.5312H48.3807C48.3935 51.2386 48.2784 51.8075 48.0355 52.2379C47.7969 52.6683 47.4815 52.9815 47.0895 53.1776C46.6974 53.3736 46.2841 53.4716 45.8494 53.4716C45.4148 53.4716 45.0185 53.3778 44.6605 53.1903C44.3026 52.9986 43.8892 52.7003 43.4205 52.2955C43.1094 52.0227 42.858 51.831 42.6662 51.7202C42.4744 51.6094 42.2656 51.554 42.0398 51.554C41.6946 51.554 41.4091 51.6754 41.1832 51.9183C40.9616 52.157 40.8551 52.5554 40.8636 53.1136H39.483Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 25,
    x2: 44,
    y2: 2,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: 25,
    x2: 44,
    y2: 2,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 55.2929,
    y1: 29.3554,
    x2: 83.355,
    y2: 1.29327,
    stroke: "black",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 29.3549,
    y1: 30.7696,
    x2: 1.29278,
    y2: 2.70748,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorDeCurentAlternativ);
export default __webpack_public_path__ + "static/media/motor_de_curent_alternativ.1e7eeebf9d4b51f9b7d09b4c3722d88b.svg";
export { ForwardRef as ReactComponent };